import { Anchor, Box, Text } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { Show } from '../../../../react-commons/components/control-flow/Show';
import { useMyNavigate } from '../router/createdRouter';

export const NotPermittedComponent= ({
                                                                                instruction = 'You are not permitted to view this page.',
                                                                            }: { instruction?: string }) => {
    const navigate = useMyNavigate();
    return (
        <Box display={'flex'} w={'100%'} h={'100%'} style={{ overflowY: 'hidden' }}>
            <Box pos={'absolute'} top={'45%'} ta={'center'} w={'100%'}>
                <IconLock size={20} style={{ transform: 'scale(6.0)', paddingBottom: 10 }} />
                <Text size={'xl'} fs={'italic'} c={'var(--mantine-text-secondary-color)'}>
                    {'Not Permitted'}
                </Text>
                <Show when={instruction}>
                    <br />
                    <Text fs={'italic'} c={'var(--mantine-text-secondary-color)'}>
                        {instruction}
                    </Text>
                </Show>
                <br />
                <Anchor
                    onClick={() => {
                        navigate({
                            route: '/projects',
                            searchParams: {},
                        });
                    }}
                    c={'var(--mantine-text-secondary-color)'}
                >
                    <Text c={'var(--mantine-text-secondary-color)'} fw={700}>
                        Back to Projects
                    </Text>
                </Anchor>
            </Box>
        </Box>
    );
};


